module.exports = __webpack_public_path__ + "images/help/video-kanban-7dceac9c5638d25c8c1c3f7d97880f40.png";